import { UserReference } from '../extViewmodels/sdk/models/User';

export enum KeepInTouchJobConfigurationScope {
	User = 0,
	Account = 1,
}

export interface IKeepInTouchJobConfiguration {
	id: string;
	name: string;
	prompt: string;
	researchInstructions: string | null;
	scope: KeepInTouchJobConfigurationScope;
	enabled: boolean;
	lastRunDate: string | null;
	lastJobId: string | null;
	creator: UserReference | null;
	creationDate: string;
	lastModifiedDate: string;
}

export interface IKeepInTouchJobConfigurationRequest {
	name: string;
	prompt: string;
	researchInstructions?: string;
	scope: KeepInTouchJobConfigurationScope;
	enabled: boolean;
}

export type KeepInTouchScoreStatus = 'Success' | 'Failed' | 'Skipped';

export interface IKeepInTouchScore {
	id: string;
	jobConfigurationId: string;
	contactId: string;
	contactOwnerId: string | null;
	jobConfigurationScope: KeepInTouchJobConfigurationScope;
	jobConfigurationCreatorId: string | null;
	score: number;
	reasoning: string | null;
	suggestedOutreach: string | null;
	webFindings: string | null;
	daysSinceLastContact: number | null;
	contactName: string | null;
	companyName: string | null;
	status: KeepInTouchScoreStatus;
	notes: string | null;
	skip: boolean;
	acknowledgedDate: string | null;
	creator: UserReference | null;
	creationDate: string;
	lastModifiedDate: string;
}

export interface IKeepInTouchScoreUpdateRequest {
	notes: string;
	skip: boolean;
}

export type KeepInTouchJobStatus = 'Queued' | 'InProgress' | 'Complete' | 'PartialSuccess' | 'Failed';

export interface IKeepInTouchProgressEntry {
	message: string;
	timestamp: string;
}

export interface IKeepInTouchContactResult {
	contactId: string;
	contactName: string | null;
	status: KeepInTouchScoreStatus;
}

export interface IKeepInTouchSystemJob {
	id: string;
	status: KeepInTouchJobStatus;
	percentComplete: number;
	contactIds: string[];
	jobConfigurationId: string | null;
	currentContactName: string | null;
	currentIndex: number;
	results: IKeepInTouchContactResult[];
	progressLog: IKeepInTouchProgressEntry[];
}

export const TERMINAL_JOB_STATUSES: KeepInTouchJobStatus[] = ['Complete', 'PartialSuccess', 'Failed'];
